module.exports = __webpack_public_path__ + "static/media/rgs_clinic_forearm_support.1c1ce604.png";